<template>
  <PropertyDetailsCard>
    <template #title>Photos</template>
    <template #action>
      <PropertyDetailsCardEditButton @click="showEditModal" v-if="images.length" />
    </template>

    <ScrollArea class="images-wrapper">
      <View gap="sm" wrap="nowrap" class="images-container">
        <PropertyImage
          v-for="(image, index) in images"
          :key="index"
          :image="image"
          :is-cover="index === 0"
          :is-large="index === 0"
          @click="fileViewerModalRef?.show(index)"
        />
      </View>
    </ScrollArea>

    <PropertyDetailsCardPlaceholder
      v-if="!images.length"
      title="You haven't added any photos yet"
      subtitle="Upload photos to highlight your property's best features"
      button-text="Add photos"
      @button-clicked="showEditModal"
    />

    <PropertyImagesModal ref="propertyImagesModalRef" />

    <FileViewerModal :files="images" ref="fileViewerModalRef">
      <template #actions="{ activeFile }">
        <IconButton variant="secondary" size="medium" shape="square" icon="trash" @click="deleteFile(activeFile.id)" />
      </template>
    </FileViewerModal>
  </PropertyDetailsCard>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { IconButton, ScrollArea, View } from '@tallo/design-system';
import { FileViewerModal } from '@tallo/file-manager';
import { usePropertyStore } from '@tallo/investor/property';
import {
  PropertyDetailsCard,
  PropertyDetailsCardEditButton,
  PropertyDetailsCardPlaceholder,
  PropertyImage,
} from '@tallo/property';

import PropertyImagesModal from './property-images-modal.vue';

const propertyStore = usePropertyStore();

const images = computed(() => propertyStore.images);
const propertyImagesModalRef = ref<InstanceType<typeof PropertyImagesModal>>();
const fileViewerModalRef = ref<InstanceType<typeof FileViewerModal>>();

function showEditModal() {
  propertyImagesModalRef.value?.modalRef?.show();
}

async function deleteFile(fileId: string) {
  await propertyStore.deleteImage(fileId);
}
</script>

<style scoped lang="scss">
.images-wrapper {
  width: 100%;
  align-items: initial;
  overflow-y: hidden;

  .images-container {
    border-radius: var(--t-border-radius-sm);
    width: fit-content;
  }
}
</style>
